module.exports = __webpack_public_path__ + "static/media/Group 2231.e2f0a225.svg";